export const ROWS_PER_PAGE = 20;

export const ACTION_BUTTONS_URL =
  "/joms/api/external/v1/payment-instrument/switch-requests";

export const PENDING_REQUESTS_HEADERS = [
  "Order ID",
  "Customer name",
  "Requested at",
  "Requested by",
  "Available limit",
  "Current payment instrument",
  "Requested payment instrument",
  "Action",
];

export const QUICK_FILTERS = {
  All: "PENDING_APPROVAL,APPROVED,REJECTED,CANCELLED",
  Pending: "PENDING_APPROVAL",
  Approved: "APPROVED",
  Rejected: "REJECTED",
  Cancelled: "CANCELLED",
};
